/**
 * Harakat tokenlarini CSS dan o'qib, `framer-motion` tushunadigan ko'rinishga
 * keltiradi. Qiymatlar shu tariqa faqat bitta joyda — `tokens.css` da turadi;
 * JS da takrorlanmaydi. Brauzerdan tashqarida (test) zaxira qiymat ishlatiladi.
 */

const readToken = (name: string): string => {
  if (typeof document === 'undefined') return '';
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
};

const cache = new Map<string, number>();

/** `--motion-base` (`220ms`) → `0.22` — framer-motion soniyada ishlaydi. */
export const motionSeconds = (name: string, fallbackMs: number): number => {
  const cached = cache.get(name);
  if (cached !== undefined) return cached;

  const raw = readToken(name);
  const match = /^([\d.]+)(ms|s)$/.exec(raw);
  const ms = match === null ? fallbackMs : Number(match[1]) * (match[2] === 's' ? 1000 : 1);
  const seconds = ms / 1000;
  cache.set(name, seconds);
  return seconds;
};

export type CubicBezier = [number, number, number, number];

/** `cubic-bezier(0.16, 1, 0.3, 1)` → `[0.16, 1, 0.3, 1]`. */
export const motionEase = (name: string, fallback: CubicBezier): CubicBezier => {
  const match = /^cubic-bezier\(([^)]+)\)$/.exec(readToken(name));
  if (match === null) return fallback;
  const parts = (match[1] ?? '').split(',').map((p) => Number(p.trim()));
  if (parts.length !== 4 || parts.some((n) => Number.isNaN(n))) return fallback;
  return [parts[0] ?? 0, parts[1] ?? 0, parts[2] ?? 0, parts[3] ?? 0];
};
